import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Paper, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SearchOffOutlinedIcon from '@mui/icons-material/SearchOffOutlined';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFoundState = ({ backPath, message }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('common');
  return (
    <Box sx={{ p: 4, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <Paper
        elevation={0}
        sx={{
          p: 4,
          maxWidth: 480,
          textAlign: 'center',
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
          bgcolor: 'background.paper',
        }}
      >
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            bgcolor: '#f3f4f6',
            color: '#6b7280',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 2,
          }}
        >
          <SearchOffOutlinedIcon sx={{ fontSize: 28 }} />
        </Box>
        <Typography variant="h6" fontWeight={700} gutterBottom>
          {t('notFound.title')}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {message || t('notFound.message')}
        </Typography>
        <Button
          variant="contained"
          startIcon={<ArrowBackIcon />}
          onClick={() => (backPath ? navigate(backPath) : navigate(-1))}
          sx={{ textTransform: 'none', fontWeight: 600 }}
        >
          {t('notFound.back')}
        </Button>
      </Paper>
    </Box>
  );
};

NotFoundState.propTypes = {
  backPath: PropTypes.string,
  message: PropTypes.string,
};

export default NotFoundState;
